<template>
	<div class="card-head">
		<span class="head-title">{{title}}</span>
		<div class="head-tab">
			<div
				class="tab-item"
				v-for="(item, index) in tabList" :key="index"
				:class="{active:currentValue == item.value }"
				@click="changeTab(item)"
			>{{item.text}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
			},
			tabList: {
				type: Array,
				default: [],
			},
		},
		data() {
			return {
				currentValue: 1
			};
		},
		async created() {

		},

		methods: {
			changeTab(item) {
				this.currentValue = item.value
				this.$emit('changeTab', item.value)
			}
		},
	};
</script>
<style lang="scss" scoped>
	.card-head{
		display: flex;
		justify-content: space-between;
		.head-title{
			font-size: 0.23rem;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
			font-weight: 500;
			color: #00FEFF;
			line-height: 0.23rem;
		}
		.head-tab{
			display: flex;
			font-size: 0.13rem;
			font-family: Source Han Sans CN-Regular, Source Han Sans CN;
			font-weight: 400;
			color: #7B8A8A;
			line-height: 0.13rem;
			.tab-item{
				padding: 0.05rem 0.03rem;
				background: rgba(255,255,255,0.05);
				border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: 0.13rem;
				cursor: pointer;
			}
			.active{
				background: rgba(0, 254, 255, 0.2);
				color: #00FEFF;
			}
		}
	}
</style>